import { Link, useParams } from "react-router-dom";
import { notices } from "@/mocks/notices";

export default function NoticeDetail() {
  const { id } = useParams<{ id: string }>();
  const index = notices.findIndex((item) => item.id === id);
  const notice = index >= 0 ? notices[index] : undefined;

  if (!notice) {
    return (
      <section className="flex min-h-[70vh] items-center justify-center bg-background-50 px-4 pt-24">
        <div className="text-center">
          <h1 className="font-heading text-3xl text-foreground-950">공지사항을 찾을 수 없습니다</h1>
          <p className="mt-3 text-sm text-foreground-600">
            요청하신 글이 삭제되었거나 주소가 잘못되었을 수 있습니다.
          </p>
          <Link
            to="/notice"
            className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-arrow-left-line" /> 목록으로
          </Link>
        </div>
      </section>
    );
  }

  const prevNotice = index > 0 ? notices[index - 1] : undefined;
  const nextNotice = index < notices.length - 1 ? notices[index + 1] : undefined;
  const paragraphs = notice.content.split("\n\n");

  return (
    <section className="bg-background-50 pt-28 md:pt-36">
      <div className="mx-auto max-w-content px-4 pb-16 md:px-6 md:pb-24">
        <nav aria-label="현재 위치" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <Link to="/" className="cursor-pointer transition-colors hover:text-primary-600">
            홈
          </Link>
          <span>/</span>
          <Link to="/notice" className="cursor-pointer transition-colors hover:text-primary-600">
            NOTICE
          </Link>
          <span>/</span>
          <span className="text-foreground-800">상세</span>
        </nav>

        <article className="mx-auto mt-6 max-w-3xl">
          <span className="inline-flex rounded-full bg-secondary-100 px-3.5 py-1.5 font-label text-xs font-medium text-secondary-800">
            {notice.category}
          </span>
          <h1 className="mt-5 font-heading text-3xl leading-snug text-foreground-950 md:text-4xl">
            {notice.title}
          </h1>
          <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 border-b border-background-200 pb-6 text-sm text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-user-line text-base" />
              {notice.author}
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-calendar-line text-base" />
              {notice.date}
            </span>
          </div>

          <div className="mt-8 space-y-5">
            {paragraphs.map((paragraph) => (
              <p key={paragraph} className="whitespace-pre-line text-sm leading-relaxed text-foreground-700 md:text-base">
                {paragraph}
              </p>
            ))}
          </div>

          <div className="mt-12 flex justify-center">
            <Link
              to="/notice"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-7 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-list-check-2" /> 목록으로 돌아가기
            </Link>
          </div>

          <div className="mt-12 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200">
            {prevNotice && (
              <Link
                to={`/notice/${prevNotice.id}`}
                className="group flex items-center gap-4 bg-background-50 px-5 py-4 transition-colors hover:bg-background-100"
              >
                <span className="flex items-center gap-1.5 shrink-0 text-xs text-foreground-500">
                  <i className="ri-arrow-up-line" /> 이전 글
                </span>
                <span className="flex-1 truncate text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                  {prevNotice.title}
                </span>
              </Link>
            )}
            {nextNotice && (
              <Link
                to={`/notice/${nextNotice.id}`}
                className="group flex items-center gap-4 bg-background-50 px-5 py-4 transition-colors hover:bg-background-100"
              >
                <span className="flex items-center gap-1.5 shrink-0 text-xs text-foreground-500">
                  <i className="ri-arrow-down-line" /> 다음 글
                </span>
                <span className="flex-1 truncate text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                  {nextNotice.title}
                </span>
              </Link>
            )}
          </div>
        </article>
      </div>
    </section>
  );
}